import { render, staticRenderFns } from "./Stortplaatsen.vue?vue&type=template&id=b19d4e1c&"
import script from "./Stortplaatsen.vue?vue&type=script&lang=js&"
export * from "./Stortplaatsen.vue?vue&type=script&lang=js&"
import style0 from "./Stortplaatsen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports